import _get from 'lodash/get';

import { Base } from '@/models';
import { toCamelCase } from '@/utilities';

export class Attachments extends Base {
  public photos?: string;
  public maintenancejob?: string;
  public invoice?: string;
  public proforma?: string;
  public clientreport?: string;

  /**
   * Constructor initialises the variables from the class Attachments
   * @param data - the data to construct a type with all properties of <Attachments>
   */
  public constructor(data?: Partial<Attachments>) {
    super(data);
    data = toCamelCase(data);

    if (_get(data, 'photos')) {
      this.photos = _get(data, 'photos');
    }

    if (_get(data, 'maintenancejob')) {
      this.maintenancejob = _get(data, 'maintenancejob');
    }

    if (_get(data, 'invoice')) {
      this.invoice = _get(data, 'invoice');
    }

    if (_get(data, 'proforma')) {
      this.proforma = _get(data, 'proforma');
    }

    if (_get(data, 'clientreport')) {
      this.clientreport = _get(data, 'clientreport');
    }
  }
}
